export default {
  data() {
    return {
      passosResources: this.$api.workflowPassos(this.$resource),
      timelinePagamento: null,
    };
  },
  methods: {
    limparTimeline() {
      this.timelinePagamento = null;
    },
    showPagamentoTimeline(pagamento) {
      if (!pagamento) {
        return;
      }
      const id = pagamento.id;
      this.passosResources.pagamento({ id }, { id })
        .then((res) => {
          this.timelinePagamento = res.data.passos;
          this.showTimeline();
        })
        .catch(() => {
          this.showTimeline();
        });
    },
    showTimeline() {
      this.openDialog('modalTimeline');
    },
    closeDialogPagamento() {
      this.$refs.modalTimeline.close();
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/passos.js